// All ten definitions in course order: the Case Card (0) and Canvases 1 to 9.
import c0 from './c0.js';
import c1 from './c1.js';
import c2 from './c2.js';
import c3 from './c3.js';
import c4 from './c4.js';
import c5 from './c5.js';
import c6 from './c6.js';
import c7 from './c7.js';
import c8 from './c8.js';
import c9 from './c9.js';

export const DEFS = [c0, c1, c2, c3, c4, c5, c6, c7, c8, c9];
export const DEF_BY_NO = Object.fromEntries(DEFS.map((d) => [d.no, d]));
